import { useQuery } from '@tanstack/react-query'
import { toast } from 'sonner'
import { queryKeys } from '@/shared/constants/query-keys'
import { getErrorMessage } from '@/shared/utils/handle-api-error'
import type { IProject, IProjectQueryById } from '../models/project'
import { type IProjectLookup, projectsService } from '../services/projects.services'

/**
 * Lookups legacy para consumidores fuera del catálogo (forms de inmuebles y
 * subtipos, filtros de negociaciones/inventario/postventa, editor de
 * plantillas). La tabla admin usa use-projects-admin-query.
 */

export const useProjectsActiveQuery = (dependence = true) => {
  return useQuery<IProject[]>({
    queryKey: queryKeys.projects.active(),
    queryFn: async () => {
      try {
        return await projectsService.getActive()
      } catch (e) {
        console.error(e)
        return []
      }
    },
    refetchOnWindowFocus: false,
    enabled: dependence
  })
}

export const useProjectsLookupQuery = (dependence = true) => {
  return useQuery<IProjectLookup[]>({
    queryKey: queryKeys.projects.lookup(),
    queryFn: async () => {
      try {
        return await projectsService.getLookup()
      } catch (e) {
        console.error(e)
        return []
      }
    },
    refetchOnWindowFocus: false,
    enabled: dependence
  })
}

export const useProjectByIdQuery = ({
  id,
  dependence = true
}: {
  id: string | null | undefined
  dependence?: boolean
}) => {
  return useQuery<IProjectQueryById | null>({
    queryKey: queryKeys.projects.detail(id ?? ''),
    queryFn: async () => {
      try {
        if (!id) return null
        return await projectsService.getById(id)
      } catch (error) {
        console.error(error)
        toast.error(getErrorMessage(error))
        return null
      }
    },
    enabled: dependence,
    refetchOnWindowFocus: false
  })
}
